(function () {
    'use strict';

    angular
        .module('vcuser.vclogin')
        .config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        // show modal for login
        $stateProvider.state('login', {
            url: '/login',
            params: {url: {}},
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                console.log('urls in onEnter: ', $stateParams.url);
                $uibModal.open({
                    template: '<div class="modalspacer"><loginform url="vm.url" dialog="vm.$uibModalInstance"></loginform></div>',
                    controllerAs: 'vm',
                    controller: ['url', '$uibModalInstance',
                        function (url, $uibModalInstance) {
                        console.log('$stateParams in uib controller: ', url);
                        let vm = this;
                        vm.url = url;
                        vm.$uibModalInstance = $uibModalInstance;
                    }],

                    resolve: {
                        url: function () {
                            console.log('url in resolve: ', $stateParams.url);
                            return $stateParams.url;
                        }
                    }
                });
            }]
        });

        $stateProvider.state('logout', {
            url: '/logout',
            onEnter: ['$state', '$http', function ($state, $http) {

                $http.get('/routes/logout')
                    .then(function () {
                        $state.go('login');
                    });
            }]
        });

    }
}());
